import React from "react";
import { ModeLookup } from "../lib/constants";
import { formatDateTime } from "../lib/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../@/components/ui/table";

interface TimeSlotProps {
  startTime: string;
  endTime: string;
  bookingDate: string;
  calenderLink: string;
  googleMeetLink: string;
  latitude: number;
  longitude: number;
  productModeId: number;
}

const VendorAdminTimeSlot: React.FC<TimeSlotProps> = ({
  startTime,
  endTime,
  bookingDate,
  calenderLink,
  googleMeetLink,
  latitude,
  longitude,
  productModeId,
}) => {
  const formattedDate = formatDateTime(bookingDate, "ddd, MMM D");
  const formattedStartTime = formatDateTime(startTime, "hh:mm A");
  const formattedEndTime = formatDateTime(endTime, "hh:mm A");

  const currentTime = new Date();
  const meetingStartTime = new Date(startTime);
  const oneHourBeforeMeeting = new Date(
    meetingStartTime.getTime() - 60 * 60 * 1000
  );

  return (
    <div className="w-full lg:max-w-xs mt-4 ml-auto border-y">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead
              colSpan={2}
              className="text-left text-customGrayBase bg-customTableBg font-semibold"
            >
              Booking Details
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell className="text-right">{formattedDate}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell className="flex items-center">
              <span>Start Time</span>
            </TableCell>
            <TableCell className="text-right">{formattedStartTime}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="flex items-center">
              <span>End Time</span>
            </TableCell>
            <TableCell className="text-right">{formattedEndTime}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <div>
        <div className="text-right font-semibold flex justify-center items-center p-4">
          {productModeId === ModeLookup.WALK_IN_SERVICE ? (
            <span className="text-customGreenColor">User will visit you</span>
          ) : productModeId === ModeLookup.VIRTUAL ? (
            currentTime >= oneHourBeforeMeeting ? (
              <a
                href={googleMeetLink ? googleMeetLink : calenderLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center items-center font-medium bg-customGreenColor text-white px-3 py-2 rounded-lg mt-4"
              >
                {googleMeetLink ? "Join Meeting" : ""}
              </a>
            ) : (
              <span className="text-gray-500 font-medium">
                Meeting will start soon
              </span>
            )
          ) : (
            <>
              <a
                href={
                  latitude && longitude
                    ? `https://www.google.com/maps/place/${latitude},${longitude}`
                    : googleMeetLink
                    ? googleMeetLink
                    : calenderLink
                }
                target="_blank"
                rel="noopener noreferrer"
                className="flex justify-center items-center font-medium bg-customGreenColor text-white px-3 py-2 rounded-lg mt-4"
              >
                {latitude && longitude
                  ? "View in Map"
                  : // : googleMeetLink
                    // ? "Join Meeting"
                    "View in Calendar"}
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorAdminTimeSlot;
